import { useMutation, useQueryClient } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';
import { message } from 'antd';

interface UpdateSessionMetadataParams {
  sessionId: string;
  display_name?: string;
  is_pinned?: boolean;
}

interface UpdateSessionMetadataResponse {
  session_id: string;
  display_name: string | null;
  is_pinned: boolean;
  status: string;
}

export function useUpdateSessionMetadata() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({
      sessionId,
      display_name,
      is_pinned,
    }: UpdateSessionMetadataParams): Promise<UpdateSessionMetadataResponse> => {
      const response = await instance.patch(`/nexa/session/${sessionId}/metadata`, {
        display_name,
        is_pinned,
      });
      return response.data;
    },
    {
      onSuccess: (data, variables) => {
        // Invalidate sessions list to refresh with new metadata
        queryClient.invalidateQueries(['nexa-sessions']);

        // Show appropriate message
        if (variables.is_pinned !== undefined) {
          message.success(variables.is_pinned ? 'Session pinned' : 'Session unpinned');
        } else if (variables.display_name !== undefined) {
          message.success('Session renamed');
        }
      },
      onError: () => {
        message.error('Failed to update session');
      },
    },
  );
}
